
{
  "fr": {
    "hours-interval": "{start} - {end}",
    "hours-acc": " et ",
    "hours-closed": "Fermé",
    "button-show": "Consulter les horaires",
    "button-hide": "Fermer les horaires"
  }
}
